import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

// Application modules
import { SharedModule } from 'src/app/shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';

// Application components
import { CampaignDetailsComponent } from './components/campaign-details/campaign-details.component';
import { CampaignListComponent } from './components/campaign-list/campaign-list.component';
import { ContactComponent } from './components/contact/contact.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { HomeComponent } from './home.component';
import { CookieComponent } from './components/cookie/cookie.component';

@NgModule({
  declarations: [
    HomeComponent,
    CampaignDetailsComponent,
    CampaignListComponent,
    EditProfileComponent,
    PrivacyComponent,
    CookieComponent,
    ContactComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],  imports: [
    CommonModule,
    SharedModule,
    HomeRoutingModule,
  ],
})
export class HomeModule { }
